import { render, staticRenderFns } from "./PatientAnalysis.vue?vue&type=template&id=6f0d156b&scoped=true"
import script from "./PatientAnalysis.vue?vue&type=script&lang=js"
export * from "./PatientAnalysis.vue?vue&type=script&lang=js"
import style0 from "./PatientAnalysis.vue?vue&type=style&index=0&id=6f0d156b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0d156b",
  null
  
)

export default component.exports